import React from 'react';
import { ApolloProvider } from '@apollo/client';
import { ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import ReactDOM from 'react-dom/client';
import { App } from 'src/App';
import { theme } from 'src/theme/index';
import { apolloClient } from 'src/utils/api';

import { bootMarketingTags } from './bootMarketingTags';
import './index.css';

if (!Object.hasOwn) {
  Object.hasOwn = (target: object, property: PropertyKey): boolean =>
    Object.prototype.hasOwnProperty.call(Object(target), property);
}

bootMarketingTags();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <ApolloProvider client={apolloClient}>
          <App />
        </ApolloProvider>
      </LocalizationProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
